import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function useRedirect() {
  const navigate = useNavigate();
  return useCallback((path) => {
    navigate(path);
  }, [navigate]);
}
